import { render } from "./BaseBanner.vue?vue&type=template&id=0ddd51bb"
import script from "./BaseBanner.vue?vue&type=script&lang=js"
export * from "./BaseBanner.vue?vue&type=script&lang=js"
script.render = render

export default script